import ChildrenEntities from 'client/components/core/ChildrenEntities'
import {
  TwoStepPaymentFormStep,
  TwoStepPaymentFormStepButton,
  TwoStepPaymentFormStepFooter,
} from 'common/components/entities/two-step-payment-form'
import { TwoStepPaymentFormStepInterface } from 'common/types/entities/two-step-payment-form-interface'
import React from 'react'

export interface TwoStepPaymentFormOptInStepProps {
  entity: TwoStepPaymentFormStepInterface
  color: string
  mobileColor?: string
  backgroundColor?: string
  mobileBackgroundColor?: string
}

export const TwoStepPaymentFormOptInStep = ({
  entity,
  color,
  mobileColor,
  backgroundColor,
  mobileBackgroundColor,
}: TwoStepPaymentFormOptInStepProps) => {
  return (
    <TwoStepPaymentFormStep>
      <ChildrenEntities
        id={entity.id}
        type={entity.type}
        childIds={entity.childIds}
      />
      <TwoStepPaymentFormStepButton
        color={color}
        mobileColor={mobileColor}
        backgroundColor={backgroundColor}
        mobileBackgroundColor={mobileBackgroundColor}
        text={entity.buttonText}
        subText={entity.buttonSubText}
      />
      {entity.footerText && (
        <TwoStepPaymentFormStepFooter>
          {entity.footerText}
        </TwoStepPaymentFormStepFooter>
      )}
    </TwoStepPaymentFormStep>
  )
}
